import {
    FavoriteBorderRounded as FavoriteBorderRoundedIcon
} from '@mui/icons-material';
import {
    Box,
    Card,
    CardMedia,
    Stack,
    Typography,
    useTheme
} from '@mui/material';
import { useTranslation } from 'react-i18next';
import TextIconLabel from 'src/components/TextIconLabel';
import { CommonHelper } from 'src/utils/commonHelper';
import ThreeDotLoader from 'src/utils/Loader/threeDotLoader.compontent';
import Comments from '../../../assets/comment.svg';
import Share from '../../../assets/fbshare.svg';

const BlueskyMobileViewPosts = ({ publishedPosts, mobileLoader, getMobileViewthreadNextPublishedPosts, pagination }) => {
  const { t: translate } = useTranslation();

  const theme = useTheme();
  const postcontentL = 220;
  const postcontentS = 110;
  return (
    <Box
      sx={{
        maxHeight: 'calc(100vh - 330px)',
        minHeight: 'calc(100vh - 330px)',
      }}
    >
      {publishedPosts.map((row, index) => {
        const { created_time, id, media_url, like_count, message, repost_count, reply_count } = row;
        return (
          <Card
            key={index}
            sx={{
              maxHeight: message?.length > 25 ? postcontentL : postcontentS,
              display: 'flex',
              flexDirection: 'row',
              mb: 1,
              p: 1,
              gap: 1,
            }}
          >
            {media_url ? (
              <CardMedia
                component="img"
                sx={{ width: 140, maxHeight: 140 }}
                image={media_url}
                alt="Post image"
              />
            ) : null}
            <Box sx={{ display: 'flex', flexDirection: 'column', p: 1, gap: 1, maxWidth: 200 }}>
              <Typography
                variant="subtitle2"
                sx={{
                  overflow: 'hidden',
                  textOverflow: 'ellipsis',
                  whiteSpace: 'pre-line',
                  display: '-webkit-box',
                  WebkitLineClamp: 2,
                  WebkitBoxOrient: 'vertical',
                }}
              >
                {message}
              </Typography>
              <Stack direction="row" justifyContent="space-between" sx={{ gap: 1 }}>
                <TextIconLabel
                  value={like_count}
                  aria-label="chatbubbleoutline"
                  sx={{ typography: 'subtitle2' }}
                  icon={<FavoriteBorderRoundedIcon fontSize="small" />}
                />
                <TextIconLabel
                  value={reply_count}
                  aria-label="chatbubbleoutline"
                  sx={{ typography: 'subtitle2' }}
                  icon={<img alt="comment" src={Comments} height={20} width={20} />}
                />
                <TextIconLabel
                  value={repost_count}
                  aria-label="chatbubbleoutline"
                  sx={{ typography: 'subtitle2' }}
                  icon={<img alt="share" src={Share} height={20} width={20} />}
                />
              </Stack>
              <Typography variant="body2" sx={{ fontSize: '10px' }} color="text.secondary">
                {CommonHelper.GetDateFormat(created_time)}
              </Typography>
            </Box>
          </Card>
        );
      })}
      {pagination && (
        <Box sx={{ textAlign: 'center' }}>
          {mobileLoader ? (
            <ThreeDotLoader />
          ) : (
            <Typography
              variant="body1"
              sx={{
                fontWeight: 700,
                textDecoration: 'underline',
                cursor: 'pointer',
                color: theme.palette.grey[500],
              }}
              onClick={getMobileViewthreadNextPublishedPosts}
            >
              {translate('published_post.load_more_posts')}
            </Typography>
          )}
        </Box>
      )}
    </Box>
  );
};
export default BlueskyMobileViewPosts;
